import styled from 'styled-components';

/** Hovering over this component will display an outline around it */

export const OutlineOnHover = styled.div`
	outline: 0;
	max-width: max-content;

	&:hover {
		outline: 1px solid ${props => props.theme.colors.grey[400]};
		border-radius: 4px;
	}
`;
